module.exports = __webpack_public_path__ + "img/share_poster_1.025a8cf6.svg";